import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative flex flex-col min-h-full p-2 border shadow-md bg-white dark:border-gray-200 dark:border dark:bg-gray-800 rounded-3xl shadow-black/5 ring-1 ring-black/5 show-card border-clay-200" }
const _hoisted_2 = ["href", "alt", "title"]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "flex flex-col flex-1 p-4" }
const _hoisted_5 = { class: "mt-2 font-medium text-base/7" }
const _hoisted_6 = ["href", "alt", "title"]
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "text-sa-raspberry-600 text-sm/5" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "sr-only" }
const _hoisted_12 = { class: "z-10 flex items-center gap-3 mx-auto mt-6" }


import Bookmarking from "@/main/components/Bookmarking.vue";
import Fanning from "@/main/components/Fanning.vue";
import {AuthorDto} from "@/dtos";


export default /*@__PURE__*/_defineComponent({
  __name: 'WriterCard',
  props: {
    writer: {}
  },
  setup(__props: any) {

const props = __props

const writer: AuthorDto = props.writer;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: `/${_unref(writer).urlSlug}`,
      alt: _unref(writer).name,
      title: _unref(writer).name,
      class: "guide-img-container"
    }, [
      _createElementVNode("img", {
        src: _unref(writer).imageUrl,
        alt: `${_unref(writer).name} logo`,
        class: "object-cover w-full aspect-square rounded-2xl"
      }, null, 8, _hoisted_3)
    ], 8, _hoisted_2),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("a", {
          href: `/${_unref(writer).urlSlug}`,
          alt: _unref(writer).name,
          title: _unref(writer).name,
          class: "text-sa-raspberry-900"
        }, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "absolute inset-0" }, null, -1)),
          _createElementVNode("h3", _hoisted_7, _toDisplayString(_unref(writer).name), 1)
        ], 8, _hoisted_6)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("p", null, [
            _createElementVNode("em", _hoisted_10, _toDisplayString(_unref(writer).jobTitles?.join(', ')), 1),
            _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(writer).jobTitles?.join(', ')) + ", ", 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(Fanning, {
          id: _unref(writer).id,
          "number-of-fans": _unref(writer).fanCount
        }, null, 8, ["id", "number-of-fans"]),
        _createVNode(Bookmarking, {
          id: _unref(writer).id
        }, null, 8, ["id"])
      ])
    ])
  ]))
}
}

})